module.exports = __webpack_public_path__ + "f31d276f8cef7827ff57e96f27c61b3e.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/fr/apple_store.svg
// module id = 841
// module chunks = 0